








import Vue from 'vue'
import iconContent from '@/assets/svg/rounded/content.svg?inline'
import iconChevronLeft from '@/assets/svg/rounded/chevron-left.svg?inline'

interface Props {
  checked: boolean
}

interface Computed {
  checkedClass: () => string
}

export default Vue.extend<{}, Computed, {}, Props>({
  components: {
    iconContent,
    iconChevronLeft
  },
  props: {
    checked: {
      required: true
    }
  },
  computed: {
    checkedClass() {
      if(this.checked) {
        return "icon-chevron-left"
      }
      return "icon-content"
    }
  }
})
